module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (133).62a48bce.jpg";